import AutosizedVerticalList from './autosized_vertical_list';

export default AutosizedVerticalList;
